// extracted by mini-css-extract-plugin
export var i18nContainer = "navbar-module--i18nContainer--yJhMC";
export var logo = "navbar-module--logo--z0ZPQ";
export var customMobileNav = "navbar-module--customMobileNav--t2D2P";
export var mobileNav = "navbar-module--mobileNav--dekoa";
export var dropDown = "navbar-module--dropDown--b5Bcn";